import { useQuery } from "@tanstack/react-query";
import { USER_API } from "config";
import { useAxios } from "hooks/useAxios";
import { scriptKeys } from "queries";
import type { TagDefinitionsReportRow } from "../lib/merge-tag-report";

export function useTagDefinitionsReport(projectId: string, documentId: string, enabled: boolean) {
  const axios = useAxios({ allResponse: false });
  return useQuery({
    queryKey: [...scriptKeys.tags(projectId, documentId), "merge-dialog"],
    enabled: Boolean(projectId && documentId) && enabled,
    queryFn: async (): Promise<TagDefinitionsReportRow[]> => {
      const body = (await axios.get(USER_API.getTagReport(projectId, documentId))) as {
        status_code?: number;
        data?: { tag_definitions_report?: TagDefinitionsReportRow[] };
      };
      return body?.data?.tag_definitions_report ?? [];
    },
  });
}
